enum LotConditionsEnum {
  UNCONDITIONAL = "No Conditions",
  FINANCE = "Finance",
  SALE_OF_HOME = "Sale of Home",
  SOIL_TEST = "Soil Test",
  COUNCIL_APPROVAL = "Council Approval",
}

export default LotConditionsEnum;
